import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// ProtectedRoute component to guard routes that require authentication and optionally specific roles
const ProtectedRoute = ({ children, requiredRole = null }) => {
    const { isLoggedIn, loading, user, hasRole } = useAuth();
    const location = useLocation();

    // Show loading spinner while checking authentication
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Chargement...</span>
                </div>
            </div>
        );
    }

    // Only redirect if we're sure the user is not logged in
    // (not during initial load, only after authentication check is complete)
    // Save the current location to redirect back after login
    if (!loading && (!isLoggedIn || !user?.data)) {
        return <Navigate to="/" replace state={{ from: location }} />; // Redirect to login if not authenticated
    }

    // Check role if required
    if (requiredRole && user?.data && !hasRole(requiredRole)) {
        return <Navigate to="/home" replace />; // Redirect to home if user doesn't have required role
    }

    return children;
};

export default ProtectedRoute;